import React from 'react';

export const LoginForm: React.FC = () => {
    return <></>;
};
